<template>
  <div class="app-show">
    <div class="info">
      <span>App:</span>
      <span>{{ app.name }}</span>
    </div>
    <div class="info">
      <span>Roles</span>
    </div>
    <div class="info">
      <btn
        name="Create new role"
        @click="create"
      />
    </div>
    <list
      class="list"
      :items="app.roles"
      :columns="columns"
      :buttons="buttons"
      @click="click"
      @edit="edit"
      @delete="deleteRole"
    />
    <form-dialog
      v-if="formDialog"
      :item="item"
      :header="headerTitle"
      @cancel="formDialog = false; editing = false;"
      @save="save"
    />
  </div>
</template>

<script>
  import gql from 'graphql-tag';

  export default {
    name: 'AppShow',
    components: {
      list: () => import('@/views/admin/components/list.vue'),
      btn: () => import('@/views/admin/components/btn.vue'),
      'form-dialog': () => import('@/views/admin/components/form-dialog.vue'),
    },
    props: {},
    data() {
      return {
        formDialog: false,
        editing: false,
        app: {},
        buttons: [{ name: 'Edit', callback: 'edit' }, { name: 'Delete', callback: 'delete' }],
        item: { name: { value: '' } },
        columns: [
          {
            name: 'Role ID',
            key: 'id',
          },
          {
            name: 'Name',
            key: 'name',
          },
        ],
      };
    },
    apollo: {
      app: {
        query: gql`query ($key: String!) {
        app (key: $key) {
          id
          name
          redirect
          url
          roles {id name}
        }
      }`,
        variables() {
          return {
            key: this.$route.params.id,
          };
        },
        skip() {
          return !this.$route.params.id;
        },
        update(data) {
          return data.app;
        },
      },
    },
    computed: {
      headerTitle() {
        return this.editing ? 'Edit role' : 'Create new role';
      },
    },
    watch: {},
    mounted() {},
    methods: {
      deleteRole(item) {
        if (window.confirm('Are you sure you want to delete this role? This will delete all grants for this role.')) {
          this.$apollo.mutate({
            mutation: gql`
                mutation($roleId: String!) {
                  deleteManyGrant(where: {role: {id: {equals: $roleId}}}) {count}
                }
              `,
            variables: {
              roleId: item.id.value,
            },
          }).then(() => {
            this.$apollo.mutate({
              mutation: gql`
                mutation($id: String!) {
                  deleteOneRole(where: {id: $id}) {
                    id
                  }
                }
              `,
              variables: {
                id: item.id.value,
              },
            }).then(() => {
              this.$apollo.queries.app.refetch();
            });
          });
        }
      },
      create() {
        this.editing = false;
        this.item = { name: { value: '' } };
        this.formDialog = true;
      },
      edit(item) {
        this.editing = true;
        this.formDialog = true;
        Object.assign(this.item, {
          id: { value: item.id, disabled: true },
          name: { value: item.name },
        });
      },
      save(item) {
        if (!this.editing) {
          this.$apollo.mutate({
            mutation: gql`
                  mutation($name: String!, $appId: String!) {
          createOneRole(data: {name: $name, app: {connect: {id: $appId}}}) {id name}
          }
          `,
            variables: {
              appId: this.app.id,
              name: item.name.value,
            },
          }).then(() => {
            this.$apollo.queries.app.refetch();
          });
        } else {
          this.$apollo.mutate({
            mutation: gql`
                mutation($name: String!, $id: String!) {
                updateOneRole(data: { name: { set: $name } }, where: {id: $id}) {
                  id
                  name
                }
              }
          `,
            variables: {
              id: item.id.value,
              name: item.name.value,
            },
          }).then(() => {
            this.$apollo.queries.app.refetch();
          });
        }
        this.editing = false;
        this.formDialog = false;
      },
      click(item) {
        const { params } = this.$route;
        this.$router.push({ name: 'admin/roles/users', params: { id: params.id, roleId: item.id } });
      },
    },
  };
</script>


<style lang="stylus" scoped>


</style>
